import axios from 'axios';

export interface UpdateGreetProfileActionProps {
  greetId: string;
  profileId?: string;
  email: string;
  firstName: string;
  lastName: string;
  note: string;
}

export default function updateGreetProfileAction({
  greetId,
  profileId,
  email,
  firstName,
  lastName,
  note,
}: UpdateGreetProfileActionProps) {
  return axios(`/api/v2/greets/${greetId}/${profileId}/update`, {
    method: 'POST',
    data: {
      email,
      first_name: firstName,
      last_name: lastName,
      message: note,
    },
  }).then((res) => res.data);
}
